import React from "react";
import { useTranslation } from "react-i18next";

function SaveConfirmModal({
  closeModal,
  handleSave,
  loading,
  msg,
  saveBtnText,
  cancleBtnText,
}: {
  closeModal: () => void;
  handleSave: () => void;
  loading?: boolean;
  msg: string;
  saveBtnText?: string;
  cancleBtnText?: string;
}) {
  const { t } = useTranslation();
  const saveText = saveBtnText || "Save";
  const cancleText = cancleBtnText || "Close";
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-5 rounded-md shadow-lg flex flex-col justify-between items-end w-[90%] sm:w-[500px] h-[auto] max-h-[80vh]">
        <div className="flex flex-col items-start justify-start gap-5 w-full">
          <h2 className="text-lg font-semibold text-red-600">
            {t("Confirm Action")}
          </h2>
          <div className="mt-2 whitespace-pre-line" dangerouslySetInnerHTML={{ __html: t(msg) }} />
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button
            className="px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded hover:bg-gray-50"
            onClick={closeModal}
          >
            {t(cancleText)}
          </button>
          <button
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? `${t("Saving")}...` : t(saveText)}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SaveConfirmModal;
